import React from "react";
import { Label } from "./ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "./ui/select";
import { useCart } from "../context/CartContext";
import { useMeta } from "../context/MetaContext";
import { MapPin, Building2 } from "lucide-react";

export const ContextBar = () => {
  const { uf, setUf, enquadramento, setEnquadramento } = useCart();
  const { ufs, enquadramentos } = useMeta();

  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 sm:gap-4" data-testid="context-bar">
      <div className="space-y-1.5">
        <Label className="flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-wide text-slate-500">
          <MapPin className="h-3.5 w-3.5" /> Estado de destino
        </Label>
        <Select value={uf} onValueChange={setUf}>
          <SelectTrigger
            className="h-11 bg-white text-[15px] font-semibold"
            data-testid="consulta-uf-select"
          >
            <SelectValue placeholder="Selecione a UF" />
          </SelectTrigger>
          <SelectContent className="max-h-72 bg-white">
            {ufs.map((u) => (
              <SelectItem key={u.sigla} value={u.sigla} data-testid={`uf-option-${u.sigla}`}>
                {u.sigla} — {u.nome}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <div className="space-y-1.5">
        <Label className="flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-wide text-slate-500">
          <Building2 className="h-3.5 w-3.5" /> Enquadramento do cliente
        </Label>
        <Select value={enquadramento} onValueChange={setEnquadramento}>
          <SelectTrigger
            className="h-11 bg-white text-[15px] font-semibold"
            data-testid="consulta-enquadramento-select"
          >
            <SelectValue placeholder="Selecione" />
          </SelectTrigger>
          <SelectContent className="bg-white">
            {enquadramentos.map((e) => (
              <SelectItem key={e.codigo} value={e.codigo} data-testid={`enq-option-${e.codigo}`}>
                {e.nome}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
};
